import apiClient from './apiClient';

export const eventsAPI = {
  getRecentEvents: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.scope) queryParams.append('scope', params.scope);
    if (params.days) queryParams.append('days', params.days);
    if (params.uniquePerSymbol) queryParams.append('uniquePerSymbol', params.uniquePerSymbol);
    if (params.symbol) queryParams.append('symbol', params.symbol);
    if (params.timeframe) queryParams.append('timeframe', params.timeframe);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);
    // Use cursor instead of nextToken for standardized cursor-based pagination
    if (params.cursor) queryParams.append('cursor', params.cursor);
    // Scope to a single custom event's fires (only honoured by the backend
    // when eventTypes includes custom_event). Lets a caller fetch ONE event's
    // full history instead of all custom events sharing one 200-row page.
    if (params.customEventId) queryParams.append('customEventId', params.customEventId);
    if (params.includeCount) queryParams.append('includeCount', params.includeCount);
    if (params.eventTypes && params.eventTypes.length) {
      queryParams.append('eventTypes', params.eventTypes.join(','));
    }
    if (params.symbols && params.symbols.length) {
      queryParams.append('symbols', params.symbols.join(','));
    }
    
    const queryString = queryParams.toString();
    const response = await apiClient.get(`/events${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },
};

export default eventsAPI;
